let deferred = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  window.dispatchEvent(new Event("install-ready"));
});

export const canPrompt = () => !!deferred;
export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
export const isMobile = () => /android|iphone|ipad|ipod/i.test(window.navigator.userAgent);
// Instagram, Facebook, TikTok, Snapchat etc. open links in their own browser, which can't install apps.
export const isInAppBrowser = () =>
  /instagram|fban|fbav|fb_iab|tiktok|musical_ly|bytedance|snapchat|twitter|line\/|; wv\)/i.test(window.navigator.userAgent);

export const openInstall = async () => {
  if (deferred) {
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    deferred = null;
    return;
  }
  window.dispatchEvent(new Event("install-help"));
};
